import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardTileStarsFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { boardStars: Array<(
    { __typename: 'BoardStar' }
    & Pick<Types.BoardStar, 'id' | 'idBoard' | 'pos'>
  )> }
);

export const BoardTileStarsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardTileStars' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boardStars' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idBoard' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pos' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardTileStarsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardTileStarsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardTileStarsFragmentResult
  extends Omit<Apollo.UseFragmentResult<BoardTileStarsFragment>, 'data'> {
  data?: BoardTileStarsFragment;
}

export const useBoardTileStarsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardTileStarsFragmentOptions): UseBoardTileStarsFragmentResult => {
  const result = Apollo.useFragment<BoardTileStarsFragment>({
    ...options,
    fragment: BoardTileStarsFragmentDoc,
    fragmentName: 'BoardTileStars',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardTileStarsFragment };
};
